<template>
<svg @init="init" class="m" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 1068 1061">
<pattern  y="1061" width="1068" height="1061" patternUnits="userSpaceOnUse" id="img2" viewBox="1 -1062 1068 1061" style="overflow:visible;">
<image style="overflow:visible;" width="1068" height="1061" xlink:href="./s1/img.jpg"  transform="matrix(1 0 0 1 1 -1062)">
</image>
</pattern>
	<defs>
		<path id="SVGID_1_" d="M570.6,603.5c12.2-10.7,67.8-59.5,90.2-79.1c160.5-140.2,260.7-47.9,332,11.9
			C943.5,585.6,885,622.4,821.9,624v37.1c79.5,12.4,160.4-40.1,246.1-124.8c-43.7-39.3-86.3-77.6-131.9-103.7
			c-48.3-27.6-146.2-58.4-247.3,24.6c-18.6,15.2-73,62.4-73,62.4l-67.5,57.7L570.6,603.5z M407.2,548.4
			C298.4,641,209.8,660.7,75.3,536.3c54-53.9,118.8-92.9,188.8-87.2v-33.7C178.8,391.5,92.3,445.3,0.2,536.3
			c137.2,139,256.9,175,379.3,79.2L538,479.9l-22.4-26.6L407.2,548.4z"/>
	</defs>
	<clipPath id="SVGID_2">
		<use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
	</clipPath>
<g style="clip-path:url(#SVGID_2);stroke-width:60;">	
		<path class="an1 l" d="M545.9,601.3c0,0,121.3-102.8,152.6-130.2c68.2-59.6,206.9-73.2,336.5,66.1c-91.2,90.5-150.9,106.6-213,106.6"/>	
		<path class="an2 l" d="M542.9,457.1c0,0-132.2,110.1-187.1,155.8c-50.9,42.3-196.4,65.2-320.3-76.4c102.1-126.4,212.2-103.2,228.6-103.2"/>
</g>
	<defs>
		<path id="SVGID_3" d="M726.7,704.8c0,10-8.1,18.1-18.1,18.1h-14.1v12.8h118.9
			V723H798c-10,0-18.1-8.1-18.1-18.1v-429c-12.6,14.9-134.6,113.4-189.3,163.5l14.7,17l121.4-102.8L726.7,704.8L726.7,704.8z
			 M590,541.6l25.7-22L506,389.3c-39.7-51-126.2-147.5,27-313.1c83.6,83.7,131.3,193.5,32.3,308C720,259.2,666.5,136.2,533,1
			c-39.3,43.7-77.6,86.3-103.7,131.9c-45.2,79-34.6,178.2,24.6,247.3L590,541.6z M542.9,651c70.8,86.1,137.4,181.9-9.9,334.8
			c-83.6-83.7-162.9-196.9-35.6-322.9c-192.5,127.5-97.8,263,35.6,398.1c195.1-190.6,161.5-325.2,37.6-457.5L304.8,292.8v412.1
			c0,10-8.1,18.1-18.1,18.1h-14.9v12.8h100.6V723H357c-10,0-18.1-8.1-18.1-18.1V413.1L542.9,651z"/>
	</defs>
	<clipPath id="SVGID_4">
		<use xlink:href="#SVGID_3"  style="overflow:visible;"/>
	</clipPath>
	<g style="clip-path:url(#SVGID_4);">
		<path class="an3 l" style="stroke-width:57;" d="M613.1,541.6c0,0-75.2-91.9-141.5-167.7C379.8,269,431.3,127.5,533.1,38.3c133.2,115.8,121.8,261.8,32.2,345.8"/>
		<path class="an4 l" style="stroke-width:57;" d="M312,342.3c0,0,188.8,218.9,247.8,287C697.6,788.4,651,908.9,534,1024.7c-113.9-106.2-195.1-234.6-36.6-361.8"/>
		<path class="an5 l" style="stroke-width:35;" d="M321.5,495V289"/>
		<path class="an6 l" style="stroke-width:120;" d="M322.9,735V488"/>
		<path class="an7 l" style="stroke-width:120;" d="M753.7,306v429.8"/>
		<path class="an8 l" style="stroke-width:29;" d="M595.2,446.5L790,280"/>
</g>
</svg>
</template>
<style lang="scss" scoped>
.m{
  .l{fill:none;stroke:url(#img2);}
.an1 {stroke-dasharray:826;stroke-dashoffset:826;animation: letterDraw 1s 1.8s linear forwards;}
.an2 {stroke-dasharray:867;stroke-dashoffset:867;animation: letterDraw 1s 1.8s linear forwards;}
.an3 {stroke-dasharray:997;stroke-dashoffset:997;animation: letterDraw 1s 1.8s linear forwards;}
.an4 {stroke-dasharray:1265;stroke-dashoffset:1265;animation: letterDraw 1.2s 1.5s linear forwards;}
.an5 {stroke-dasharray:203;stroke-dashoffset:203;animation: letterDraw .2s 1.3s linear forwards;}
.an6 {stroke-dasharray:248;stroke-dashoffset:248;animation: letterDraw .3s 1s linear forwards;}
.an7 {stroke-dasharray:430;stroke-dashoffset:430;animation: letterDraw .8s 2.3s linear forwards;}
.an8 {stroke-dasharray:257;stroke-dashoffset:257;animation: letterDraw .5s 1.8s linear forwards;}
@keyframes letterDraw {
    to {
        stroke-dashoffset: 0
    }
}
}
</style>

<script>
export default {
  name: 'm',
  components: {},

  methods: {},
}
</script>
